import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { Grid, Toolbar } from '@material-ui/core';
import request from '../../utils/request';
import DataItem from '../../data/Item';
import Button from '../../core/Button';
import FilePreview from '../../core/File/Preview';
/**
 * @extends {React.Component<import('./types').AnalyticsDashboardFrameProps>}
 */

var AnalyticsDashboardFrame =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AnalyticsDashboardFrame, _React$Component);

  function AnalyticsDashboardFrame() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnalyticsDashboardFrame);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnalyticsDashboardFrame)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.frame = React.createRef();
    _this.state = {
      pendingRefresh: false
    };

    _this.refresh = function () {
      _this.setState({
        pendingRefresh: true
      });

      return request({
        url: '/backend/systemanalytics/refresh',
        method: 'POST'
      }).then(function (res) {
        _this.onRefreshCompleted();
      });
    };

    _this.rebuild = function () {
      _this.setState({
        pendingRefresh: true
      });

      return request({
        url: '/backend/systemanalytics/rebuild',
        method: 'POST'
      }).then(function (res) {
        _this.onRefreshCompleted();
      });
    };

    _this.onRefreshCompleted = function () {
      _this.setState({
        pendingRefresh: false
      });

      _this.frame.current.send('AnalyticsDashboard.dataProvider.refresh');
    };

    return _this;
  }

  _createClass(AnalyticsDashboardFrame, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          workspace = _this$props.workspace,
          path = _this$props.path,
          systemAnalytics = _this$props.systemAnalytics,
          toolbar = _this$props.toolbar,
          rest = _objectWithoutProperties(_this$props, ["workspace", "path", "systemAnalytics", "toolbar"]);

      if (typeof systemAnalytics !== 'undefined') {
        return React.createElement(React.Fragment, null, toolbar && React.createElement(Toolbar, null, React.createElement(DataItem, {
          dataType: "systemAnalyticsStatus",
          id: "stats",
          refreshInterval: true
        }, function (data) {
          return data && data.value ? React.createElement(Grid, {
            container: true,
            direction: "row",
            justify: "space-between",
            alignItems: "center"
          }, React.createElement(React.Fragment, null, React.createElement(Grid, {
            item: true,
            xs: true
          }), React.createElement(Grid, {
            item: true
          }, React.createElement(Button, {
            variant: "contained",
            onClick: _this2.refresh,
            disabled: _this2.state.pendingRefresh || data.value.HasBuildingVersion
          }, _this2.state.pendingRefresh || data.value.HasBuildingVersion ? 'Refreshing...' : 'Refresh')))) : null;
        })), React.createElement(DataItem, {
          dataType: "systemAnalytics",
          id: systemAnalytics
        }, function (data) {
          return data.value && data.value.Dashboards && data.value.Dashboards.length ? React.createElement(FilePreview, Object.assign({
            workspace: data.value.Dashboards[0].Workspace,
            path: data.value.Dashboards[0].Path,
            frameBaseRef: _this2.frame
          }, rest)) : null;
        }));
      } else if (typeof workspace !== 'undefined') {
        return React.createElement(FilePreview, Object.assign({
          workspace: workspace,
          path: path,
          frameBaseRef: this.frame
        }, rest));
      } else {
        return null;
      }
    }
  }]);

  return AnalyticsDashboardFrame;
}(React.Component);

AnalyticsDashboardFrame.defaultProps = {};
export default AnalyticsDashboardFrame;